import React, { useEffect, useState } from "react";
import Edit_Non_Work from "./edit_Non_Work/Edit_Non_Work";
import Non_Work_Form from "./non_Work_Form/Non_Work_Form";
import Non_Work_table from "./non_Work_table/Non_Work_table";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import {
  Create,
  GetAll,
  Update,
  Delete,
} from "../../../../../../../src/features/admin/quality_management/process_requirement/non_confirming_work/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/fixIDS";
import Delete_offcanvas from "../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";

function Non_Work() {
  const dispatch = useDispatch();

  const non_confirming_workdetails = useSelector(
    (state) => state.non_confirming_work,
  );
  const permissions = useSelector((state) => state.auth.permissions);
  const haveDeletePermission = permissions?.includes(
    FixIDS.non_confirming_work.Delete,
  );
  const haveReadPermission = permissions?.includes(
    FixIDS.non_confirming_work.List,
  );
  const haveAddPermission = permissions?.includes(
    FixIDS.non_confirming_work.Add,
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const handleEdit = (id) => {
    setEditData(id);
    setIsEdit(true);
  };

  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(Delete(selectedDeleteId)).unwrap();

      fetchCustomers(currentPage); //  refresh table
      //setDelete(false);            //  close offcanvas
      setSelectedDeleteId(null); // reset
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: non_confirming_workdetails.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);

  return (
    <section className="Imperiality">
      {isEdit ? (
        <>
          <div className="back_div">
            <Common_Back_Btn backText="Edit Non-Confirming Work" />
          </div>

          <Edit_Non_Work id={editData} onCancel={() => setIsEdit(false)} />
        </>
      ) : (
        <>
          <div className="back_div">
            <Common_Back_Btn backText="Non-Confirming Work" />
          </div>

          <div className="imperiality_Form_div">
            {haveAddPermission && <Non_Work_Form />}
          </div>

          <div className="imperiality_table_div">
            {haveReadPermission && (
              <Non_Work_table
                non_confirming_workdetails={non_confirming_workdetails}
                onEdit={handleEdit}
                ondelete={
                  haveDeletePermission
                    ? (id) => {
                        setSelectedDeleteId(id);
                        setDelete(true); // open delete popup
                      }
                    : null
                }
              />
            )}
          </div>
        </>
      )}

      {haveDeletePermission && (
        <Delete_offcanvas
          show={showDelete}
          handleClose={() => setDelete(false)}
          handleDelete={handleDelete}
          offcanvasHeading="Delete Non-Confirming Work"
          massageText={"Non-Confirming Work"}
        />
      )}
    </section>
  );
}

export default Non_Work;
